import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { QUERY_KEYS } from '@hero/constants';

import { services } from '../../services';

export const useGetAutomation = ({ code }, options = {}) => {
  const { includeGoLiveChecks, ...queryOptions } = options;

  const goLiveQuery = useQuery(
    [QUERY_KEYS.useGetAutomationApprovalKey, code],
    () => services.goLiveFlags(code),
    {
      enabled: !!code && includeGoLiveChecks
    }
  );

  const automationQuery = useQuery(
    [QUERY_KEYS.useGetAutomationKey, code],
    () => services.detail(code),
    {
      enabled: !!code,
      ...queryOptions
    }
  );

  return useMemo(() => {
    if (includeGoLiveChecks) {
      if (automationQuery?.data && goLiveQuery?.data) {
        automationQuery.data.approval = goLiveQuery.data;
      }

      return {
        ...automationQuery,
        data: automationQuery?.data,
        refetch: () => {
          automationQuery.refetch();
          goLiveQuery.refetch();
        },
        isFetched: automationQuery.isFetched && goLiveQuery.isFetched,
        isFetching: automationQuery.isFetching || goLiveQuery.isFetching,
        isLoading: automationQuery.isLoading || goLiveQuery.isLoading
      };
    }

    return automationQuery;
  }, [goLiveQuery, automationQuery, goLiveQuery]);
};
